import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtInputCurrency from '@/common/components/mvtinputcurrency/mvt-inputcurrency.vue';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import mvtToggleSwitch from '@/common/components/mvttoggleswitch/mvt-toggle-switch.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import mapper from '@/common/store/mapper/index.js';
import searchFilters from '@/msp/mixins/searchfilters';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';
import { deleteSubscription, updateSubscriptionBySubscription, toggleAllSubscriptions, enableSubscription, disableSubscription, checkAllowed } from '../../utilities/nojq/_notification.js';
import { setStorage, getStorage } from '../../utilities/nojq/_localstorage.js';

var _valideBed = function (type) {
    var _validateBedRex = /(MULTI_FAMILY|LAND|OTHER)/;
    if (Array.isArray(type)) {
        return type.some(function (val) {
            return !_validateBedRex.test(val);
        });
    }
    return !_validateBedRex.test(type);
};
var mergeArray = function (a1, a2) {
    var array = [];
    if (Array.isArray(a1)) {
        if (Array.isArray(a2)) {
            array = a1.concat(a2);
        } else {
            return a1;
        }
    } else if (Array.isArray(a2)) {
        return a2;
    } else {
        return [];
    }
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
            if (a[i] === a[j]) {
                a.splice(j--, 1);
            }
        }
    }
    return a;
};
export default {
    name: 'mvtFeed',
    components: {
        mvtCardProperty,
        mvtRadio,
        mvtCheckbox,
        mvtTextbox,
        mvtInputCurrency,
        mvtToggleSwitch,
    },
    mixins: [searchFilters],
    inject: ['$eventBus'],
    props: {
        property: {
            type: Object,
            default: null
        },
        isNotification: {
            type: Boolean,
            default:false
        }
    },
    data() {
        return {
            active: false,
            list: [],
            index: 0,
            edit: false,
            bedroomData: [
                {
                    text: 'Any Bed',
                    value: 0
                }, {
                    text: '1+ Beds',
                    value: 1
                }, {
                    text: '2+ Beds',
                    value: 2
                }, {
                    text: '3+ Beds',
                    value: 3
                }, {
                    text: '4+ Beds',
                    value: 4
                }, {
                    text: '5+ Beds',
                    value: 5
                }
            ],
            propertyTypeData: [
                {
                    text: `<i class="icon-property-single-family"></i> House`,
                    value: 'SINGLE_FAMILY_HOUSE'
                }, {
                    text: `<i class="icon-property-condo"></i> Condo`,
                    value: 'CONDO'
                }, {
                    text: `<i class="icon-property-multi-family"></i> Multi`,
                    value: 'MULTI_FAMILY'
                }, {
                    text: `<i class="icon-property-lot"></i> Land`,
                    value: 'LAND'
                }, {
                    text: `<i class="icon-property-mobile"></i> Mobile`,
                    value: 'MOBILE'
                }, {
                    text: `<i class="icon-property-other"></i> Other`,
                    value: 'OTHER'
                }
            ],
            notification: [],
            blockNotification: true,
            allDisabled: false,
        }
    },
    inject: ['$eventBus'],
    methods: {
        ...mapActions('glb', ['getHousesBySearchUrl', 'addSaveSearch']),
        ...mapMutations('glb', ['addFeed', 'updateFeed', 'removeFeed']),
        saveFeedToEmail() {
            var data = {
                userId: this.glb.user.id,
                trigger: this.$options.name,
                lite: true,
                userType: this.glb.pageInfo.userType,
                schoolRequest: this.getSchoolRequest,
                ...this.getBaseDataForSaveSearch()
            };
            this.addSaveSearch(data).then(res => {
                this.$eventBus.$emit('dialog-center', {name: 'mvtConfirm', opt: {
                    componentName: 'mvtConfirmAuth',
                    searchName: data.searchName.split(',')[0]
                }, trigger: this.$options.name});
            });
        },
        getBaseDataForSaveSearch() {
            var item = this.getData[this.index];
            var path = this.getUrl(item.maxPrice, item.minBed, item.propertyType, item.stateCode, item.zipcode)

            return {
                url: path,
                searchName: this.savedName({filter: {...item, beds: item.minBed}})
            };
        },
        savedName(state) {
            let saveName = [];
            if(state.filter.stateCode && state.filter.zipcode) {
                saveName.push(`${state.filter.zipcode} ${state.filter.stateCode.toUpperCase()}`)
            }
            this.getFeedFilters(state).forEach(filter => {
                filter.isActive() && saveName.push(filter.getLabel());
            });

            return saveName.join(', ');
        },
        toogleEdit(){
            this.edit = !this.edit;
        },
        refresh(index) {
            var that = this;
            this.index = index;
            var item = this.getData[this.index];
            var path = this.getUrl(item.maxPrice, item.minBed, item.propertyType, item.stateCode, item.zipcode)
            this.getHousesBySearchUrl({ path: path }).then(function (result) {
                if (result.listings && result.listings.length) {
                    that.list = result.listings.map(function (e) {
                        return mapper.property(e, that.glb);
                    });
                    that.edit = false;
                } else {
                    that.edit = true;
                    that.list = [];
                }
            });
        },
        getDataByPropery(property) {
            if (!property) {
                return null;
            }
            return {
                zipcode: property.geo && property.geo.zipcode,
                stateCode: property.geo && property.geo.stateCode,
                propertyType: [property.propertyType],
                propertyTypeDisplayName: [property.propertyTypeDisplayName],
                maxBed: property.bed * 1 + 1,
                minBed: property.bed * 1,
                maxPrice: isNaN(property.price) ? NaN : Math.floor(property.price * 1.1),
                minPrice: isNaN(property.price) ? NaN : Math.floor(property.price * 0.75),
                updateTime: new Date()
            };
        },
        getUrl(maxPrice, minBed, propertyType, stateCode, zipcode) {
            let geo = {
                zipcode: zipcode,
                stateCode: stateCode,
            };
            let filter = {
                propertyType: propertyType,
                minBed: minBed,
                maxPrice: maxPrice,
            };
            return getPathBySearchObj(geo, filter);
        },
        updateFeed(newFeed){
            if (newFeed && newFeed.zipcode && newFeed.stateCode) {
                var i = this.getData.findIndex(function (e) {
                    return e.zipcode === newFeed.zipcode && e.stateCode === newFeed.stateCode;
                });
                if (i >= 0) {
                    var item = this.getData[i];
                    item.propertyType = mergeArray(item.propertyType, newFeed.propertyType);
                    item.propertyTypeDisplayName = mergeArray(item.propertyTypeDisplayName, newFeed.propertyTypeDisplayName);
                    item.minBed = isNaN(item.minBed) ? newFeed.minBed : (isNaN(newFeed.minBed) ? item.minBed : Math.min(item.minBed, newFeed.minBed));
                    item.maxBed = isNaN(item.maxBed) ? newFeed.maxBed : (isNaN(newFeed.maxBed) ? item.maxBed : Math.max(item.maxBed, newFeed.maxBed));
                    item.minPrice = isNaN(item.minPrice) ? newFeed.minPrice : (isNaN(newFeed.minPrice) ? item.minPrice : Math.min(item.minPrice, newFeed.minPrice));
                    item.maxPrice = isNaN(item.maxPrice) ? newFeed.maxPrice : (isNaN(newFeed.maxPrice) ? item.maxPrice : Math.min(item.maxPrice, newFeed.maxPrice));
                    item.updateTime = newFeed.updateTime;
                    this.updateFeed(i, item);
                } else {
                    this.addFeed(newFeed);
                }
            }
            setStorage('feed', this.getData);
        },
        deleteSelectedNotification(){
            var that = this;
            var sub = this.selectedItem;
                deleteSubscription({
                    zipcodes: [sub.zipcode]
                }).then(function(){
                    that.notification = getStorage('saveSearchRecord');
                    if(that.index >=0 && that.index < that.getData.length){
                        that.refresh(that.index);
                    }else if(that.getData.length > 0 && that.index > 0){
                        that.refresh(that.index-1);
                    }
                });
        },
        deleteSelectedFeed(){
            this.removeFeed(this.index);
            if(this.index >=0 && this.index < this.getData.length){
                this.refresh(this.index);
            }else if(this.getData.length > 0 && this.index > 0){
                this.refresh(this.index-1);
            }
            setStorage('feed', this.getData);
        },
        saveFeed(){
            var that = this;
            if(this.isNotification){
                updateSubscriptionBySubscription(this.selectedItem).then(function(){
                    that.notification = getStorage('saveSearchRecord');
                    that.refresh(that.index);
                });
            }else{
                this.getData[this.index].updateTime = new Date();
                setStorage('feed', this.getData);
                this.refresh(this.index);
            }
        },
        syncFeed(property) {
            var newFeed = this.getDataByPropery(property);
            this.updateFeed(newFeed);
        },
        disableAll() {
            this.updateAllSubscriptions(false)
        },
        toggleAll(){
            var allDisabled = this.getData.filter(function(e){
                return !e.disabled
            }).length === 0;
            if(!allDisabled) {
                this.showConfirmDialog()
            }
            else {
                this.updateAllSubscriptions(allDisabled)
            }
        },
        showConfirmDialog() {
            this.$eventBus.$emit('dialog-center', {name: 'unsubscribeConfirm', opt: {type: 'unsubscribeConfirmDialog'}, trigger: this.$options.name});
        },
        updateAllSubscriptions(allDisabled) {
            var that = this;
            toggleAllSubscriptions(allDisabled).then(function(){
                that.notification = getStorage('saveSearchRecord');
                setStorage('disableNotification', !allDisabled);
                that.allDisabled = !allDisabled;
            });
        },
        toggle(){
            var that = this;
            var sub = this.selectedItem;
            if(sub.disabled){
                enableSubscription({
                    zipcodes: [sub.zipcode]
                }).then(function(){
                    that.notification = getStorage('saveSearchRecord');
                    setStorage('disableNotification', false);
                    that.allDisabled = false;
                });
            }else{
                var isLastOne = this.getData.filter(function(e){
                    return !e.disabled
                }).length === 1;
                if(isLastOne){
                   this.toggleAll();
                }else{
                    disableSubscription({
                        zipcodes: [sub.zipcode]
                    }).then(function(){
                        that.notification = getStorage('saveSearchRecord');
                    })
                }
            }

        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getFeed']),
        ...mapGetters('msp', ['msp', 'getSchoolRequest']),
        selectedItem(){
            return this.getData[this.index];
        },

        getData(){
            var data =[];
            if(this.isNotification){
                data = this.notification;
            } else {
                data = this.getFeed;
            }
            return data;
        }
    },
    created() {
        !this.glb.isSSR &&
            this.$eventBus.$on('disableall-notifications', () => {
                this.disableAll();
        });
    },
    beforeUnmount() {
        this.$eventBus.$off('disableall-notifications');
    },
    mounted() {
        var that = this;
        if (this.property) {
            this.syncFeed(this.property);
        } else {
            this.blockNotification = !checkAllowed();
            this.allDisabled = getStorage('disableNotification') || false;
            this.notification = getStorage('saveSearchRecord');
            this.active = true;

            const urlParams = new URLSearchParams(window.location.search);
            const disableFlagData = urlParams.get('disable');
            let disableFocusIndex, enabledItemCount = 0,
                disableAllItemFlag = (disableFlagData === 'all'),
                itemNotDisabled;

            if(this.isNotification && disableAllItemFlag && !this.allDisabled) {
                that.showConfirmDialog()
            }

            if (this.getData && this.getData.length > 0) {
                var i = 0, time=0;
                this.getData.forEach(function(item,index){
                    var newTime = +new Date(item.updateTime);
                    if(newTime > time){
                        time = newTime;
                        i = index;
                    }
                    if (!item.disabled) {
                        enabledItemCount++;
                    }
                    if (disableFlagData === item.zipcode) {
                        disableFocusIndex = index;
                        itemNotDisabled = !item.disabled;
                        item.disabled = true;
                    }
                });

                if (disableFlagData && disableFocusIndex >= 0) {
                    if (disableFocusIndex)
                        i = disableFocusIndex;

                    if (itemNotDisabled) {
                        if (enabledItemCount === 1) {
                            toggleAllSubscriptions(false);
                            this.allDisabled = true;
                        } else {
                            disableSubscription({
                                zipcodes: [disableFlagData]
                            });
                        }
                    }
                }
                setTimeout(function(){
                    const evt = new Event('click');
                    var link = $('.mvt-feed-filter').find('a')[i];
                    if(link){
                        link.dispatchEvent(evt);
                        link.scrollIntoView();
                    }
                },10);
            }
        }

        this.$eventBus.$on('eventbus-disableSubscription',function(zipcode){
           if(that.selectedItem && that.selectedItem.zipcode === zipcode){
                that.selectedItem.disabled = true;
           }
        });
    },
}

